module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-253.d9b89da.woff2";